module.exports = __webpack_public_path__ + "img/congratulationsSendForm.4de8662d.png";